const getRuntimeFramework = () => {
  if (typeof window !== "undefined" && window?.__NEXT_DATA__ === void 0) {
    return "podo";
  }
  return "next";
};

export { getRuntimeFramework };
//# sourceMappingURL=getRuntimeFramework.mjs.map
